import cx from 'classnames';
import React from 'react';
export const Heading = ({ children, className, contrast, is: Tag = 'span', looksLike, weight, ...rest }) => {
    if (Tag === looksLike) {
        console.debug('[TDS Heading] prop "looksLike" is only necessary if it differs from "is"');
    }
    return (React.createElement(Tag, { className: cx({
            [`tds-text--${looksLike}`]: looksLike,
            [`tds-text--${weight}`]: weight,
            [`tds-text--contrast-${contrast}`]: contrast,
        }, className), ...rest }, children));
};
